// TODO: This page is for backward compatibility with old login flow use sso instead
// TODO: Remove this page after the old login flow is deprecated

import { me } from '@connected/api-client/data/auth/me';
import { isAuthenticated, removeAuthentication, setAuthentication, tokenSchema } from '@connected/api-client/lib/authentication';
import { getLoginUrl, navigateToLogin } from '@connected/api-client/lib/login';
import { Button } from '@connected/ui/components/button';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';
import { z } from 'zod';

import { AUTH_DEBUG, FALLBACK_REDIRECT } from '@/config/auth';
import { queryClient } from '@/lib/query-client';

export const Route = createFileRoute('/login/')({
    validateSearch: z.object({
        token: tokenSchema.optional(),
        redirect: z.string().optional(),
    }),
    beforeLoad: async ({ search }) => {
        if (search?.token) {
            const redirectTo = search.redirect ? decodeURIComponent(search.redirect) : undefined;

            try {
                setAuthentication(search.token);
            }
            catch (e) {
                console.error('Failed to set authentication:', e);
                removeAuthentication();
                throw redirect({
                    href: getLoginUrl(FALLBACK_REDIRECT),
                });
            }

            await queryClient.invalidateQueries(me.queryOptions());

            if (redirectTo?.includes('login')) {
                toast.success('Redirecting to root');
                throw redirect({
                    to: FALLBACK_REDIRECT,
                });
            }

            toast.success(`Redirecting to ${redirectTo}`);
            throw redirect({
                to: redirectTo || FALLBACK_REDIRECT,
            });
        }

        if (isAuthenticated() && !AUTH_DEBUG) {
            throw redirect({
                to: FALLBACK_REDIRECT,
            });
        }

        if (AUTH_DEBUG) {
            return;
        }

        // Redirect to portaal login with fallback path (not current URL to avoid loops)
        throw redirect({
            href: getLoginUrl(FALLBACK_REDIRECT),
        });
    },
    component: Layout,
});

function Layout() {
    if (!isAuthenticated() && AUTH_DEBUG) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Button
                    onClick={() => navigateToLogin({ redirectPath: FALLBACK_REDIRECT })}
                >
                    Niet ingelogd, inloggen (Nu login)
                </Button>
            </div>
        );
    }

    if (AUTH_DEBUG) {
        return <p>Je bent ingelogd</p>;
    }

    return null;
}
